import { Injectable } from '@angular/core';

/**
 * Service to refresh authentication session.
 * @see https://dev.azure.com/KHTechnologySolutions/Decision%20Support%20Tool/_workitems/edit/5406/
 * @see https://dev.azure.com/KHTechnologySolutions/Decision%20Support%20Tool/_workitems/edit/6024/
 */
@Injectable({ providedIn: 'root' })
export class AuthSessionRefresherService {
  maybeRefreshOnContinue(): Promise<void> {
    console.log('maybeRefreshOnContinue not implemented yet');
    //TODO(jack hensley - sep 25 2025): implement session refresh
    return Promise.resolve();
  }
}
